export const CONTACT_TYPES = [
  { value: 'person', labelKey: 'contacts:types.person' },
  { value: 'company', labelKey: 'contacts:types.company' },
  { value: 'authority', labelKey: 'contacts:types.authority' },
  { value: 'vendor', labelKey: 'contacts:types.vendor' },
];

export const CONTACT_TYPE_VALUES = CONTACT_TYPES.map((t) => t.value);

export const EMPTY_PHONE = { temp_id: null, country_code: '+45', number: '', label: '' };
export const EMPTY_EMAIL = { temp_id: null, email: '', label: '' };

export const EMPTY_ADDRESS = {
  address_line1: '',
  address_line2: '',
  postal_code: '',
  city: '',
  country: 'Denmark',
};

export const EMPTY_CONTACT = {
  name: '',
  att: '',
  contact_type: 'company',
  role: '',
  phone_numbers: [],
  emails: [],
  address: null,
  website: '',
  cvr_number: '',
};
